// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Qdg3","content":"LoadingAlert_content__3BiVS"};